/**
 * reducers/redaction.ts
 * desc: client redaction
 * note:
 */

import type { Reducer } from '@reduxjs/toolkit';
import type { RedactionAction } from '../actions/redaction';
import type { DataDeletionSummary } from '../../types/api/redaction';

export interface RedactionState {
    isLoading: {
        gdprDeletion: boolean;
    };
    // an empty object until the first deletion summary arrives
    detail: DataDeletionSummary[] | Record<string, never>;
}

const INITIAL_STATE: RedactionState = {
    isLoading: {
        gdprDeletion: false,
    },
    detail: {}
};


function redactionReducer(state: RedactionState = INITIAL_STATE, action: RedactionAction): RedactionState {
    switch (action.type) {
        // POST GDPR deletion
        case 'REDACTION_GDPR_DELETION_ERROR':
            return _gdprDeletionError(state);
        case 'REDACTION_GDPR_DELETION_REQUEST':
            return _gdprDeletionRequest(state);
        case 'REDACTION_GDPR_DELETION_SUCCESS':
            return _gdprDeletionSuccess(state, action.payload);

        default:
            return state;
    }
}



//*************************************************
//*****   POST GDPR deletion  *********************
//*************************************************
function _gdprDeletionError(state: RedactionState): RedactionState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            gdprDeletion: false,
        },
    };
}

function _gdprDeletionRequest(state: RedactionState): RedactionState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            gdprDeletion: true,
        },
    };
}

function _gdprDeletionSuccess(state: RedactionState, payload: DataDeletionSummary[]): RedactionState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            gdprDeletion: false,
        },
        detail: payload
    };
}

export default redactionReducer as Reducer<RedactionState>;
